__turbopack_context__.v({
  "sandbox": "SandboxedHtml-module-scss-module__yBAtFa__sandbox",
});
